export const getMarketingBarsSeen = state => state.marketingBarsSeen;
